import React from 'react';

import { cssMap } from '@atlaskit/css';
import AiGenerativeCleanupIcon from '@atlaskit/icon-lab/core/ai-generative-cleanup';
import IconTile from '@atlaskit/icon/icon-tile';
import { Box, Inline, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	cardWrapper: {
		borderRadius: token('radius.xlarge'),
		border: `${token('border.width')} solid ${token('color.border')}`,
	},
	cardContent: {
		paddingBlock: token('space.200'),
		paddingInline: token('space.200'),
	},
});

export function ArchiveTeamsCardSkeleton(): React.JSX.Element {
	return (
		<Stack xcss={styles.cardWrapper}>
			<Box xcss={styles.cardContent} testId="archive-teams-card-skeleton">
				<Inline space="space.150" alignBlock="center" spread="space-between">
					<Inline space="space.150" alignBlock="center">
						<IconTile icon={AiGenerativeCleanupIcon} label="" appearance="gray" size="medium" />
						<Stack space="space.050">
							<Skeleton width={140} height={20} borderRadius={token('radius.small')} isShimmering />
							<Skeleton width={100} height={16} borderRadius={token('radius.small')} isShimmering />
						</Stack>
					</Inline>
				</Inline>
			</Box>
		</Stack>
	);
}
